import { useContext } from 'react'
import {
  PageContentContext,
  PageContext,
  PageFooterContext,
  PageHeaderContext,
  PageMetaContext,
  PageSeoContext,
  PageSiteMetaContext,
} from '../providers'

export const usePage = () => useContext(PageContext)
export const usePageMeta = () => useContext(PageMetaContext)
export const usePageContent = () => useContext(PageContentContext)
export const useHeaderContent = () => useContext(PageHeaderContext)
export const useSeo = () => useContext(PageSeoContext)
export const useFooter = () => useContext(PageFooterContext)
export const useSiteMeta = () => useContext(PageSiteMetaContext)
